// APP
export const APP_ERROR = 'APP_ERROR';
export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SET_SELECTED_DRIVER = 'SET_SELECTED_DRIVER';
export const RESET_DRIVER_CHARGERS = 'RESET_DRIVER_CHARGERS';
export const RESET_CHARGERS = 'RESET_CHARGERS';


//SIGNUP
export const SIGN_UP_SET_STATE = 'SIGN_UP_SET_STATE';
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR';
export const RESET_SIGN_UP_STATE = 'RESET_SIGN_UP_STATE';

// USER
export const USER_INFO_ERROR = 'USER_INFO_ERROR';
export const USER_INFO_LOADING = 'USER_INFO_LOADING';
export const SET_IS_OPU = 'SET_IS_OPU';

//CARD
export const GET_USER_PAYMENT = 'GET_USER_PAYMENT';
export const SET_USER_PAYMENT = 'SET_USER_PAYMENT'; 
export const UPDATE_USER_PAYMENT = 'UPDATE_USER_PAYMENT';
export const DELETE_USER_PAYMENT = 'DELETE_USER_PAYMENT';
export const CREATE_PAYMENT_TOKEN = 'CREATE_PAYMENT_TOKEN';
export const CHARGE_TOKEN = 'CHARGE_TOKEN';


// GET
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_USER_LOCATIONS = 'GET_USER_LOCATIONS';
// SET
export const SET_IS_LOGED_IN = 'SET_IS_LOGED_IN';
export const SET_USER_TRANSACTION_UUID = 'SET_USER_TRANSACTION_UUID';
export const SET_SYSTEM_ID = 'SET_SYSTEM_ID';
export const SET_REMOTE_TRANSACTION_ID = 'SET_REMOTE_TRANSACTION_ID';
export const SET_USER_INFO = 'SET_USER_INFO';

// CHARGERS
export const CHARGERS_ERROR = 'CHARGERS_ERROR';
export const SET_CHARGER_LOADING = 'SET_CHARGER_LOADING';
export const SELECT_CHARGER = 'SELECT_CHARGER';
export const SELECT_CHARGER_CONNECTOR = 'SELECT_CHARGER_CONNECTOR';
export const SET_CURRENT_STREAM = 'SET_CURRENT_STREAM';
export const STOP_CURRENT_STREAM = 'STOP_CURRENT_STREAM';
export const SET_CHARGERS = 'SET_CHARGERS';
export const SET_CHARGERS_ARRAY = 'SET_CHARGERS_ARRAY';
export const SET_DRIVER_CHARGERS = 'SET_DRIVER_CHARGERS';
export const SET_PUBLIC_CHARGERS = 'SET_PUBLIC_CHARGERS';
export const UPDATE_CHARGER_STATUS = 'UPDATE_CHARGER_STATUS';
export const UPDATE_CHARGER_GROUP = 'UPDATE_CHARGER_GROUP';
export const UPDATE_CHARGER_CONNECTOR_STATUS = 'UPDATE_CHARGER_CONNECTOR_STATUS';
export const RESET_SELECTED_CHARGER = 'RESET_SELECTED_CHARGER';
export const SET_CONNECTOR_LOADING = 'SET_CONNECTOR_LOADING';
export const UPDATE_TRANSACTION_DATA = 'UPDATE_TRANSACTION_DATA';
export const CLEAR_TRANSACTION_DATA = 'CLEAR_TRANSACTION_DATA';
export const UPDATE_CHARGING_SUMMERY = 'UPDATE_CHARGING_SUMMERY';
export const SET_USER_CHARGERS_PEREFERENCES = 'SET_USER_CHARGERS_PEREFERENCES';

// DRIVERS
export const DRIVERS_ERROR = 'DRIVERS_ERROR';
export const SELECT_DRIVER = 'SELECT_DRIVER';
export const SET_DRIVERS = 'SET_DRIVERS';

export const UPDATE_DRIVER_CHARGER_STATUS = 'UPDATE_DRIVER_CHARGER_STATUS';
export const UPDATE_DRIVER_CHARGER_CONNECTOR_STATUS = 'UPDATE_DRIVER_CHARGER_CONNECTOR_STATUS';
export const SET_DRIVER_CHARGER_LOADING = 'SET_DRIVER_CHARGER_LOADING';
export const SET_DRIVER_CONNECTOR_LOADING = 'SET_DRIVER_CONNECTOR_LOADING';


// CARS
export const CARS_ERROR = 'CARS_ERROR';
export const SELECT_CAR = 'SELECT_CAR';
export const SET_CARS = 'SET_CARS';

// MAIN
export const MAIN_SCREEN_INFO = 'MAIN_SCREEN_INFO';
export const MAIN_SCREEN_LOADING = 'MAIN_SCREEN_LOADING';
export const MAIN_SCREEN_ERROR = 'MAIN_SCREEN_ERROR';

// PROFILES
export const SELECT_PROFILE = 'SELECT_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const PROFILES_ERROR = 'PROFILES_ERROR';
export const SET_MAX_AMP_ALLOWED = 'SET_MAX_AMP_ALLOWED';
export const SET_PROFILE_TYPE = 'SET_PROFILE_TYPE';
export const SET_ACTIVE_PROFILES = 'SET_ACTIVE_PROFILES';


// INVOICES
export const GET_INVOICES = "GET_INVOICES"
export const GET_INVOICES_TOTAL_DATA = "GET_INVOICES_TOTAL_DATA"
export const GET_MONTHLY_INVOICE = "GET_MONTHLY_INVOICE"
export const SAVE_DATES = "SAVE_DATES"

// TAGS
export const GET_TAGS = 'GET_TAGS';
export const SET_TAGS = 'SET_TAGS';
export const SET_TAGS_ARRAY = 'SET_TAGS_ARRAY';
export const UPDATE_TAG = 'UPDATE_TAG';
export const REMOVE_TAG = 'REMOVE_TAG';
export const SET_TAG_ACTION = 'SET_TAG_ACTION';
export const TAGS_ERROR = 'TAGS_ERROR';





